import { render, staticRenderFns } from "./TaskDraggable.vue?vue&type=template&id=faa24d16"
import script from "./TaskDraggable.vue?vue&type=script&lang=js"
export * from "./TaskDraggable.vue?vue&type=script&lang=js"
import style0 from "./TaskDraggable.vue?vue&type=style&index=0&id=faa24d16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports